import React from "react";

const OverlayPage = ({ handleClick }) => {
    
    return (
        <div className="page-overlay" onClick={handleClick} />
    );
}
 
export default OverlayPage;